/**
 * External dependencies
 */
import { combineReducers } from 'redux';
import { reduce, get, omit } from 'lodash';

/**
 * Internal dependencies
 */
import { createReducer } from 'state/utils';
import {
    KIOSK_PLANS_RECEIVE,
    KIOSK_PLANS_REQUEST,
    KIOSK_PLANS_REQUEST_SUCCESS,
    KIOSK_PLANS_REQUEST_FAILURE,
    CURRENT_KIOSK_RECEIVE,
} from 'state/action-types';

export const items = createReducer([], {
    [KIOSK_PLANS_RECEIVE]: (state, action) => {
        return reduce(
            action.payload.items,
            (memo, subscription) => {
                const { id } = subscription;
                if (memo === state) {
                    memo = { ...memo };
                }
                memo[id] = subscription;
                return memo;
            },
            state,
        );
    },
});

export const requesting = createReducer(false, {
    [KIOSK_PLANS_REQUEST]: () => true,
    [KIOSK_PLANS_REQUEST_SUCCESS]: () => false,
    [KIOSK_PLANS_REQUEST_FAILURE]: () => false,
});


export const error = createReducer(false, {
    [KIOSK_PLANS_REQUEST]: () => false,
    [KIOSK_PLANS_REQUEST_SUCCESS]: () => false,
    [KIOSK_PLANS_REQUEST_FAILURE]: () => true,
});


export default combineReducers({
    items,
    requesting,
    error
});
